import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import Comments from './Comments';

const FooterPicker = () => {
  const { pageContentResource } = usePageContentContext();
  const isMobile = useMobileLayout();

  return pickFunction(pageContentResource, {
    [fr.relationships.facetPlanCommentThreads.name]: () => {
      if (!isMobile) {
        return null;
      }
      return (<Comments />);
    },
    [fr.relationships.default.name]: () => null,
  });
};

export default FooterPicker;
